/**
 * ResponsiveImg.jsx
 * Drop-in replacement for <img> that ships an 800w WebP to phones and
 * 1600w WebP to desktop, with sensible defaults for lazy/decoding/CLS-free
 * rendering (explicit width + height).
 *
 * Usage:
 *   <ResponsiveImg srcId="photo-1623944156546-ddd5bf10796e"
 *                  alt="Shipping logistics"
 *                  className="..." />
 */
import { U_MOBILE, U_DESKTOP } from "@/lib/content";

export default function ResponsiveImg({
  srcId,
  alt,
  className,
  width  = 1600,
  height = 1000,
  loading = "lazy",
  fetchPriority,
  ...rest
}) {
  const mobile  = U_MOBILE(srcId);
  const desktop = U_DESKTOP(srcId);
  return (
    <picture>
      <source media="(max-width: 768px)" srcSet={mobile}  type="image/webp" />
      <source                            srcSet={desktop} type="image/webp" />
      <img
        src={desktop}
        alt={alt}
        width={width}
        height={height}
        loading={loading}
        decoding="async"
        fetchpriority={fetchPriority}
        className={className}
        {...rest}
      />
    </picture>
  );
}
